import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { connect } from 'react-redux';
import BatchDetails from '../BatchDetails/BatchDetails';
import DownloadBatch from '../DownloadBatch';
import TransactionList from '../Transactions/TransactionList';
import BatchAudit from '../BatchAudit/BatchAudit';
import { getBatchTypes, getBatchStatuses } from '../../../../../../Redux/Actions/CommonActions';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../api-config';
import { auth } from '../../../../../../services/auth.service';
import IsLoading from '../../../../../Shared/Loading/IsLoading';

class DialogContainer extends Component {
    constructor(props) {
        super(props);
        let d = { ...this.props.dataItem };
        d["IsAssignedToAtLeastOneTransaction"] = null;
        this.state = {
            view: "details",
            data: Object.keys(this.props.dataItem).length === 0 ? null : d
        };
    }

    componentDidMount() {
        this.props.getBatchTypes();
        this.props.getBatchStatuses();
        if (this.state.data) {
            axios.post(`${ROOT_API_URL}/ManageBatches/DoesBatchHaveAtLeastOneTransaction`, this.state.data, { headers: auth.authHeader() })
                .then((response) => {
                    let d = { ...this.state.data };
                    d["IsAssignedToAtLeastOneTransaction"] = response.data;
                    this.setState({
                        data: d
                    })
                });
        }
    }

    changeVeiw = (view) => {
        this.setState({
            view: view
        })
    }

    render() {
        return (
            <div className="k-window-content">
                <div className="row " style={{ width: '100%' }}>
                    <div className="col-md-2 larger-font">
                        {this.state.data?
                            <ul className="subSideNav">
                                <li onClick={() => this.changeVeiw("details")} className={this.state.view === "edit" ? "active" : ""}>Batch Details</li>
                                <li onClick={() => this.changeVeiw("transactions")} className={this.state.view === "add" ? "active" : ""}>Transactions</li>
                                <li onClick={() => this.changeVeiw("download")} className={this.state.view === "add" ? "active" : ""}>Download Batch</li>
                                <li onClick={() => this.changeVeiw("audit")} className={this.state.view === "add" ? "active" : ""}>Audit History</li>
                            </ul>
                            :""}
                    </div>
                    <div className="col-md-10">
                        {this.state.view === "details" ?
                            !this.state.data || this.state.data.IsAssignedToAtLeastOneTransaction != null ?
                            <BatchDetails
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem}
                                save={this.props.save}
                                toggleStatus={this.props.toggleStatus}
                                cancel={this.props.cancel}
                                batchTypes={this.props.common.batchTypes}
                                batchStatuses={this.props.common.batchStatuses}
                                deleteBatch={this.props.deleteBatch}
                            />
                                :(<div>
                                    <IsLoading message="Loading details" />
                                </div>

                                ) :""}
                        {this.state.view === "transactions" ?
                            <TransactionList
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem}
                                cancel={this.props.cancel}
                                getTransactions={this.props.getTransactions}
                            />
                            : ""}  
                        {this.state.view === "download" ?
                            <DownloadBatch
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem}
                                cancel={this.props.cancel}
                                batchTypes={this.props.common.batchTypes}
                                batchStatuses={this.props.common.batchStatuses}
                            />
                            : ""}    
                        {this.state.view === "audit" ?
                            <BatchAudit
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem}
                                cancel={this.props.cancel}
                                batchTypes={this.props.common.batchTypes}
                                batchStatuses={this.props.common.batchStatuses}
                            />
                            : ""}    
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        common: state.common
    };
}

export default connect(mapStateToProps, {
    getBatchTypes,
    getBatchStatuses
})(DialogContainer);

